import { Input } from "@amzn/stencil-react-components/form";
import { Row } from "@amzn/stencil-react-components/layout";
import { Label } from "@amzn/stencil-react-components/text";
import React from "react";
import "src/components/commonStyles.scss";
import {useAppDispatch, useAppSelector} from "src/state/hooks";
import {updateBindleId} from "src/state/slice/EventModelSlice";

const STRINGS_DISPLAYED = {
  bindle_selector_label: "Owning bindle",
  bindle_selector_placeholder: "Enter bindle id",
}

type props = {
  disabled: boolean;
}

/**
 * Renders the bindle selector component to let the users
 * add the bindle which will own the event model.
 * for event model configurations.
 */
export const BindleSelector = ({disabled}: props) => {
  const dispatch = useAppDispatch();
  const eventModelState = useAppSelector(({eventModel}) => eventModel);
  return <Row
    alignItems={"center"} 
    justifyContent={"space-between"}
    width={"fit-content"}
  >
    <Label 
      fontSize={"20px"} 
      fontWeight={"bold"} 
      htmlFor={"bindle-input"}
      className={"width_200_px"}
    >
      {STRINGS_DISPLAYED.bindle_selector_label}
    </Label>
    <Input
      id={"bindle-input"} 
      placeholder={STRINGS_DISPLAYED.bindle_selector_placeholder}
      width={"400px"}
      onChange={(e) => {
        dispatch(updateBindleId(e?.target?.value))
      }}
      disabled={disabled}
      value={eventModelState.bindleId}
    />
  </Row>;
}
